<template>
  <div
    ref="root"
    :style="{
      backgroundColor: defaultOverlayColor,
      height,
    }"
    class="default-overlay"
  />
</template>

<script>
import {
  computed,
  defineComponent,
  nextTick,
  ref,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import useContent from '@/composables/useContent';
import { DEFAULT_OVERLAY_COLOR } from '@/js/constants';

export default defineComponent({
  name: 'DefaultOverlayComponent',

  setup() {
    const { hasMediaContent, currentContent } = useContent();

    const root = ref(null);
    const height = ref('0');
    const defaultOverlayColor = computed(() => (hasMediaContent
      ? (currentContent.value.styles.vertical_overlay_bg_color || DEFAULT_OVERLAY_COLOR)
      : ''));

    async function setHeight() {
      height.value = '0'; // reset height from previous content
      await nextTick();
      const parent = root.value.parentNode;
      height.value = `${parent.scrollHeight}px`;
    }

    onMounted(() => {
      setHeight();
      window.addEventListener('resize', setHeight);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setHeight);
    });

    return {
      root,
      height,
      defaultOverlayColor,
    };
  },
});
</script>

<style lang="scss" scoped>
.default-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  min-height: 100%;
  z-index: 0;
  pointer-events: none;

  @media screen and (orientation: landscape) and (min-width: $desktop_s_breakpoint) {
    display: none;
  }

  @media screen and (max-height: $mobile_height_breakpoint) {
    display: none;
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    display: block;
  }
}
</style>
